module.exports = __webpack_public_path__ + "static/media/Services-03.ffa4297b.jpg";